import { render, staticRenderFns } from "./QuizInfo.vue?vue&type=template&id=da042bdc&"
import script from "./QuizInfo.vue?vue&type=script&lang=js&"
export * from "./QuizInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuizInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports